import CommonPriceField from "./CommonPriceField";

export default CommonPriceField;
